import { Paper } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import PageLayout from '../../../atoms/PageLayout';
import AccountingData from './AccountingData';
import DeliveryFees from './DeliveryFees';
import OfferLists from './OfferLists';
import TaxReturns from './TaxReturns';
import WarehouseFees from './WarehouseFees';
import PendingWarehouseFees from './PendingWarehouseFees';
var ExportCsvPage = function () {
    var t = useTranslation().t;
    return (React.createElement(PageLayout, { title: t('admin.exportCsv.title') },
        React.createElement(Paper, { elevation: 3, sx: { p: 3, mb: 4 } },
            React.createElement(TaxReturns, null)),
        React.createElement(Paper, { elevation: 3, sx: { p: 3, mb: 4 } },
            React.createElement(AccountingData, null)),
        React.createElement(Paper, { elevation: 3, sx: { p: 3, mb: 4 } },
            React.createElement(DeliveryFees, null)),
        React.createElement(Paper, { elevation: 3, sx: { p: 3, mb: 4 } },
            React.createElement(WarehouseFees, null)),
        React.createElement(Paper, { elevation: 3, sx: { p: 3, mb: 4 } },
            React.createElement(PendingWarehouseFees, null)),
        React.createElement(Paper, { elevation: 3, sx: { p: 3 } },
            React.createElement(OfferLists, null))));
};
export default ExportCsvPage;
export { AccountingData, DeliveryFees, OfferLists, TaxReturns };
